<template>
  <div>
    <BaseButton
      variant="salmon"
      @click="modalOpen = true"
    >
      <template slot="iconMiddle">
        <Icon
          view-box="0 0 24 24"
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <Edit />
        </Icon>
      </template>
    </BaseButton>

    <Modal
      :open="modalOpen"
      size="max-w-screen-md"
      @close="modalOpen = false"
    >
      <div class="bg-white border-b-2">
        <div class="flex justify-between px-6 pb-6">
          <h3 class="text-lg font-medium">
            Edit company details
          </h3>
          <button
            class="text-gray-500 focus:outline-none"
            @click="modalOpen = false"
          >
            <Icon
              view-box="0 0 24 24"
              class="w-5 h-5 transform rotate-45"
            >
              <Plus />
            </Icon>
          </button>
        </div>
      </div>

      <EditCompanyForm @close="modalOpen = false" />
    </Modal>
  </div>
</template>

<script>
import Modal from '@components/Modal'
import EditCompanyForm from '@components/EditCompanyForm'
import Icon from '@components/Icons/Icon'
import Edit from '@components/Icons/Edit'
import Plus from '@components/Icons/Plus'

export default {
  components: {
    Modal,
    EditCompanyForm,
    Icon,
    Edit,
    Plus
  },

  data() {
    return {
      modalOpen: false
    }
  }
}
</script>
